import React from "react";
import { useNavigate } from "react-router-dom";
import "./MobileBottomNav.css";

const MobileBottomNav = () => {
  const navigate = useNavigate();

  return (
    <nav className="mobile-bottom-nav" aria-label="Mobile bottom navigation">
      <button
        type="button"
        className="mobile-bottom-nav-item"
        onClick={() => navigate("/dashboard?view=sports-book")}
      >
        <img
          src={`${process.env.PUBLIC_URL}/Images/navigation-images/football.png`}
          alt=""
          aria-hidden="true"
        />
        <span>Sports Book</span>
      </button>

      <button
        type="button"
        className="mobile-bottom-nav-item"
        onClick={() => navigate("/dashboard")}
      >
        <img
          src={`${process.env.PUBLIC_URL}/Images/navigation-images/in-play.png`}
          alt=""
          aria-hidden="true"
        />
        <span>In Play</span>
      </button>

      <button
        type="button"
        className="mobile-bottom-nav-home"
        onClick={() => navigate("/")}
        aria-label="Home"
      >
        <span className="mobile-bottom-nav-home-circle">
          <img
            src={`${process.env.PUBLIC_URL}/Images/navigation-images/home.png`}
            alt=""
            aria-hidden="true"
          />
        </span>
      </button>

      <button
        type="button"
        className="mobile-bottom-nav-item"
        onClick={() => navigate("/dashboard?view=casino")}
      >
        <img
          src={`${process.env.PUBLIC_URL}/Images/navigation-images/casino.png`}
          alt=""
          aria-hidden="true"
        />
        <span>Casino</span>
      </button>

      <button
        type="button"
        className="mobile-bottom-nav-item"
        onClick={() => navigate("/all-games-lobby")}
      >
        <img
          src={`${process.env.PUBLIC_URL}/Images/navigation-images/megaphone.png`}
          alt=""
          aria-hidden="true"
        />
        <span>Popular</span>
      </button>
    </nav>
  );
};

export default MobileBottomNav;
